import { useMemo } from 'react'

import { TCheckinWidgetBox, TCheckinWidgetSectionItems, TSection, TSectionContent } from 'interface'
import DayWidgetSkeleton from 'components/DayWidgetSkeleton'
import { DayWidget } from 'components'
import { Column } from 'components/Flex'

import { Grid, GridItem } from '@interco/inter-ui/components/Grid'
import { Text } from '@interco/inter-ui/components/Text'

import * as S from '../../styles'

type TProps = {
  section: TSection
  isRefetching: boolean
}

const Checkin = ({ section, isRefetching }: TProps) => {
  const SectionItem = ({ items }: { items: TCheckinWidgetSectionItems[] }) =>
    (items || []).map((item: TCheckinWidgetSectionItems) => (
      <Column key={item.header} $gap="26px" $alignItems="start" style={{ marginTop: '8px' }}>
        <Text variant="body-3" semiBold>
          {item?.header}
        </Text>

        <Grid templateColumns="2fr 2fr" gap="16px" style={{ width: '100%' }}>
          {item?.checkIns.map((checkinWidget: TCheckinWidgetBox, key: number) => (
            <GridItem
              key={checkinWidget.title}
              column={checkinWidget.content.state.includes('DAY_7') ? 'span 2' : 'span 1'}
            >
              {isRefetching ? (
                <DayWidgetSkeleton />
              ) : (
                <DayWidget
                  key={checkinWidget.title}
                  id={key + 1}
                  alert={item.alert}
                  {...checkinWidget}
                />
              )}
            </GridItem>
          ))}
        </Grid>
      </Column>
    ))

  const SectionContent = useMemo(
    () =>
      (section?.content || []).map((content: TSectionContent) => (
        <div key={content.sectionTitle}>
          <Text variant="headline-h1" semiBold style={{ marginBottom: '8px' }}>
            {content?.sectionTitle}
          </Text>
          <SectionItem items={content?.sectionItems as TCheckinWidgetSectionItems[]} />
        </div>
      )),
    [section, isRefetching],
  )

  return <S.Section>{SectionContent} </S.Section>
}

export default Checkin
